/**
 * @flow
 */

import { addLocaleData } from 'react-intl';
import isLocaleSupported from 'intl-locales-supported';
import negotiateLocale from './negotiate-locale';

export const DEFAULT_LOCALE = 'en';
export const localeMap = {
  da: 'Dansk',
  de: 'Deutsch',
  el: 'Ελληνικά',
  en: 'English',
  es: 'Español',
  fi: 'Suomen kieli',
  fr: 'Français',
  it: 'Italiano',
  ja: '日本語',
  nl: 'Nederlands',
  'nl-BE': 'Nederlands (België)',
  no: 'Norsk',
  pt: 'Português',
  sv: 'Svenska',
  'zh-HK': '粤语',
};

function hasIntl(locale: string): boolean {
  return (window.Intl && isLocaleSupported(locale));
}

export function loadLocaleData(locales: Array<string> | string): Promise<[string, Object]> {
  if (!Array.isArray(locales)) {
    locales = [locales];
  }

  const locale = negotiateLocale(locales, Object.keys(localeMap)) || DEFAULT_LOCALE;

  return new Promise((resolve, reject) => {
    switch (locale) {
      case 'da':
        if (hasIntl('da')) {
          require.ensure(['react-intl/locale-data/da', '../translations/locales/da.json'], require => {
            const localeData = require('react-intl/locale-data/da');
            const messages = require('../translations/locales/da.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/da.js', 'react-intl/locale-data/da', '../translations/locales/da.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/da.js');
          const localeData = require('react-intl/locale-data/da');
          const messages = require('../translations/locales/da.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'de':
        if (hasIntl('de')) {
          require.ensure(['react-intl/locale-data/de', '../translations/locales/de.json'], require => {
            const localeData = require('react-intl/locale-data/de');
            const messages = require('../translations/locales/de.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/de.js', 'react-intl/locale-data/de', '../translations/locales/de.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/de.js');
          const localeData = require('react-intl/locale-data/de');
          const messages = require('../translations/locales/de.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'el':
        if (hasIntl('el')) {
          require.ensure(['react-intl/locale-data/el', '../translations/locales/el.json'], require => {
            const localeData = require('react-intl/locale-data/el');
            const messages = require('../translations/locales/el.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/el.js', 'react-intl/locale-data/el', '../translations/locales/el.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/el.js');
          const localeData = require('react-intl/locale-data/el');
          const messages = require('../translations/locales/el.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'en':
        if (hasIntl('en')) {
          require.ensure(['react-intl/locale-data/en', '../translations/locales/en.json'], require => {
            const localeData = require('react-intl/locale-data/en');
            const messages = require('../translations/locales/en.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/en.js', 'react-intl/locale-data/en', '../translations/locales/en.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/en.js');
          const localeData = require('react-intl/locale-data/en');
          const messages = require('../translations/locales/en.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'es':
        if (hasIntl('es')) {
          require.ensure(['react-intl/locale-data/es', '../translations/locales/es.json'], require => {
            const localeData = require('react-intl/locale-data/es');
            const messages = require('../translations/locales/es.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/es.js', 'react-intl/locale-data/es', '../translations/locales/es.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/es.js');
          const localeData = require('react-intl/locale-data/es');
          const messages = require('../translations/locales/es.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'fi':
        if (hasIntl('fi')) {
          require.ensure(['react-intl/locale-data/fi', '../translations/locales/fi.json'], require => {
            const localeData = require('react-intl/locale-data/fi');
            const messages = require('../translations/locales/fi.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/fi.js', 'react-intl/locale-data/fi', '../translations/locales/fi.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/fi.js');
          const localeData = require('react-intl/locale-data/fi');
          const messages = require('../translations/locales/fi.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'fr':
        if (hasIntl('fr')) {
          require.ensure(['react-intl/locale-data/fr', '../translations/locales/fr.json'], require => {
            const localeData = require('react-intl/locale-data/fr');
            const messages = require('../translations/locales/fr.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/fr.js', 'react-intl/locale-data/fr', '../translations/locales/fr.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/fr.js');
          const localeData = require('react-intl/locale-data/fr');
          const messages = require('../translations/locales/fr.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'it':
        if (hasIntl('it')) {
          require.ensure(['react-intl/locale-data/it', '../translations/locales/it.json'], require => {
            const localeData = require('react-intl/locale-data/it');
            const messages = require('../translations/locales/it.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/it.js', 'react-intl/locale-data/it', '../translations/locales/it.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/it.js');
          const localeData = require('react-intl/locale-data/it');
          const messages = require('../translations/locales/it.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'ja':
        if (hasIntl('ja')) {
          require.ensure(['react-intl/locale-data/ja', '../translations/locales/ja.json'], require => {
            const localeData = require('react-intl/locale-data/ja');
            const messages = require('../translations/locales/ja.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/ja.js', 'react-intl/locale-data/ja', '../translations/locales/ja.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/ja.js');
          const localeData = require('react-intl/locale-data/ja');
          const messages = require('../translations/locales/ja.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'nl':
        if (hasIntl('nl')) {
          require.ensure(['react-intl/locale-data/nl', '../translations/locales/nl_NL.json'], require => {
            const localeData = require('react-intl/locale-data/nl');
            const messages = require('../translations/locales/nl_NL.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/nl-NL.js', 'react-intl/locale-data/nl', '../translations/locales/nl_NL.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/nl-NL.js');
          const localeData = require('react-intl/locale-data/nl');
          const messages = require('../translations/locales/nl_NL.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'nl-BE':
        if (hasIntl('nl-BE')) {
          require.ensure(['react-intl/locale-data/nl', '../translations/locales/nl_BE.json'], require => {
            const localeData = require('react-intl/locale-data/nl');
            const messages = require('../translations/locales/nl_BE.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/nl-BE.js', 'react-intl/locale-data/nl', '../translations/locales/nl_BE.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/nl-BE.js');
          const localeData = require('react-intl/locale-data/nl');
          const messages = require('../translations/locales/nl_BE.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      // NOTE: Norwegian not supported by the polyfill
      case 'no':
        require.ensure(['react-intl/locale-data/no', '../translations/locales/no.json'], require => {
          const localeData = require('react-intl/locale-data/no');
          const messages = require('../translations/locales/no.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'pt':
        if (hasIntl('pt')) {
          require.ensure(['react-intl/locale-data/pt', '../translations/locales/pt.json'], require => {
            const localeData = require('react-intl/locale-data/pt');
            const messages = require('../translations/locales/pt.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/pt.js', 'react-intl/locale-data/pt', '../translations/locales/pt.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/pt.js');
          const localeData = require('react-intl/locale-data/pt');
          const messages = require('../translations/locales/pt.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'sv':
        if (hasIntl('sv')) {
          require.ensure(['react-intl/locale-data/sv', '../translations/locales/sv.json'], require => {
            const localeData = require('react-intl/locale-data/sv');
            const messages = require('../translations/locales/sv.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/sv.js', 'react-intl/locale-data/sv', '../translations/locales/sv.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/sv.js');
          const localeData = require('react-intl/locale-data/sv');
          const messages = require('../translations/locales/sv.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      case 'zh-HK':
        if (hasIntl('zh-HK')) {
          require.ensure(['react-intl/locale-data/zh', '../translations/locales/zh_HK.json'], require => {
            const localeData = require('react-intl/locale-data/zh');
            const messages = require('../translations/locales/zh_HK.json');
            addLocaleData(localeData);
            resolve([locale, messages]);
          });
          return;
        }

        require.ensure(['intl', 'intl/locale-data/jsonp/zh-Hans-HK.js', 'react-intl/locale-data/zh', '../translations/locales/zh_HK.json'], require => {
          require('intl');
          require('intl/locale-data/jsonp/zh-Hans-HK.js');
          const localeData = require('react-intl/locale-data/zh');
          const messages = require('../translations/locales/zh_HK.json');
          addLocaleData(localeData);
          resolve([locale, messages]);
        });
        break;

      default:
        return reject('Unsupported locale');
    }
  });
}



// WEBPACK FOOTER //
// ./src/lib/locale-loader.js